import { Component } from '@angular/core';
import { FieldType  } from '@ngx-formly/core';

@Component({
  standalone: false,
  selector: 'app-formly-field-checkbox',
  templateUrl: './formly-field-checkbox.component.html',
  styleUrls: ['./formly-field-checkbox.component.scss']
})
export class FormlyFieldCheckboxComponent extends FieldType
{
}
